const ITEMS = [
  "Photonic Inference",
  "Simulation First",
  "Mach-Zehnder Interferometry",
  "Waveguide Compute",
  "Coherent Light",
  "Photodetector Arrays",
];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
          <span className="px-8">{item}</span>
          <span className="text-laser">·</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee bg-ink py-5" data-testid="marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
